import React from "react";
import { connect } from "react-redux";
import styles from "./projectcard.module.scss";
import PropTypes from "prop-types";
import { colors } from "../../modules/theme";
import { ArrowRightSolid } from "../icons";
import {
  setActiveFeatureByName,
  setSidebarIsOpen,
  setActiveProject,
} from "../../actions/ui";
import { useIsMobile } from "../../hooks/mobile.js";

const ProjectCard = (props) => {
  const {
    project,
    activeCard,
    tabIndex,
    setActiveFeatureByName,
    setSidebarIsOpen,
    setActiveProject,
  } = props;

  const isMobile = useIsMobile();

  return (
    <div
      className={`${styles.sidebarCard} ${
        activeCard ? styles.activeCard : styles.inactiveCard
      }`}
      style={{
        border: activeCard ? `2px solid ${colors.linkGreen}` : "none",
      }}
      onClick={(e) => {
        if (isMobile) {
          setActiveFeatureByName(project.region);
          setSidebarIsOpen(false);
        }
        setActiveProject(project.project);
      }}
    >
      <div className={styles.projectContainer}>
        <div className={styles.projectLeft}>
          <span className={styles.projectCardIconContainer}>
            {project.image && (
              <img
                src={"data:image/svg+xml," + encodeURIComponent(project.image)}
                alt={project.project}
                className={styles.projectIcon}
                style={{ height: "auto", width: "50px", marginRight: "16px" }}
                aria-hidden="true"
              />
            )}
          </span>
        </div>
        <div className={styles.projectRight}>
          <h4
            className={styles.projectCardHeader}
            style={{
              color: colors.darkGreen,
              fontSize: activeCard ? "23px" : "18px",
            }}
          >
            {project.project}
          </h4>

          <div className={styles.projectInfo}>
            <div className={styles.projectLocation}>
              in{" "}
              <span style={{ color: colors.linkGreen }}>
                {project.location}
              </span>
            </div>
            <div className={styles.projectDescription}>
              {project.description}
            </div>
            <div className={styles.projectOrganisation}>
              Organisation: {project.organisation + ". "}
            </div>
            <div className={styles.projectAmount}>
              Grant amount: {project.grant_amount}
            </div>
            <div className={styles.projectFTE}>
              Ongoing jobs to be created:{" "}
              {project.fte_ongoing_jobs_to_be_created}
            </div>
            <div className={styles.projectFund}>
              {project.program === "Regional Investment Attraction Fund"
                ? "*"
                : ""}
              Fund name: {project.program}
            </div>
            <div className={styles.projectRound}>Round: {project.round}</div>
          </div>

          {project.link && (
            <div>
              <a
                rel={"external"}
                href={
                  project.link.startsWith("http")
                    ? project.link
                    : `http://${project.link}`
                }
                tabIndex={tabIndex}
                target="_blank"
                style={{ marginRight: 5, color: colors.linkGreen }}
              >
                Visit website
              </a>
              <ArrowRightSolid color={colors.linkGreen} height={10} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (s) => ({});

ProjectCard.propTypes = {
  project: PropTypes.object,
  activeCard: PropTypes.bool,
  tabIndex: PropTypes.number,
  setActiveFeatureByName: PropTypes.func.isRequired,
  setSidebarIsOpen: PropTypes.func.isRequired,
  setActiveProject: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setActiveFeatureByName,
  setSidebarIsOpen,
  setActiveProject,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectCard);



// WEBPACK FOOTER //
// ./src/components/projectCard/projectCard.js